module.exports = __webpack_public_path__ + "static/media/20170806_44day_2171AT.3a9cfa46.jpg";